const Time = [
  {
    time: "10:00",
    shift: "AM",
  },
  {
    time: "10:30",
    shift: "AM",
  },
  {
    time: "11:00",
    shift: "AM",
  },
  {
    time: "11:30",
    shift: "AM",
  },
  {
    time: "12:00",
    shift: "PM",
  },
  {
    time: "12:30",
    shift: "PM",
  },
  {
    time: "01:00",
    shift: "PM",
  },
  {
    time: "01:30",
    shift: "PM",
  },
  {
    time: "02:00",
    shift: "PM",
  },
  {
    time: "02:30",
    shift: "PM",
  },
  {
    time: "03:00",
    shift: "PM",
  },
  {
    time: "03:30",
    shift: "PM",
  },
  {
    time: "04:00",
    shift: "PM",
  },
  {
    time: "04:30",
    shift: "PM",
  },
  {
    time: "05:00",
    shift: "PM",
  },

  {
    time: "05:30",
    shift: "PM",
  },
  {
    time: "06:00",
    shift: "PM",
  },
  {
    time: "06:30",
    shift: "PM",
  },
  {
    time: "07:00",
    shift: "PM",
  },
  {
    time: "07:30",
    shift: "PM",
  },
  {
    time: "08:00",
    shift: "PM",
  },
  {
    time: "08:30",
    shift: "PM",
  },
  {
    id: 9,
    time: "09:00",
    shift: "PM",
  },
];
export default Time;
